var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkout__button_cover"},[_c('button',{staticClass:"checkout__button",attrs:{"disabled":_vm.totalItems === 0},on:{"click":_vm.goToCheckout}},[_vm._v("\n    Checkout\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }